import {Component, OnInit} from '@angular/core';
import {MesConfigService} from "common-shared";
import {Observable} from "rxjs";
import {StateService} from "web-shared";
import {map} from "rxjs/operators";

@Component({
  selector: 'app-dashboard-changelog',
  templateUrl: './dashboard-changelog.component.html',
  styles: [
  ]
})
export class DashboardChangelogComponent implements OnInit {
  changelog$: Observable<string>;
  nrOfEntries = 5;

  constructor(private configService: MesConfigService, public stateService: StateService) { }

  ngOnInit(): void {
    this.changelog$ = this.configService.getChangelog().pipe(map(log => {
      const index = log.indexOf('<h3>');
      const split = log.substring(index).split('<h3>');
      return split.slice(0, split.length >= this.nrOfEntries ? this.nrOfEntries + 1 : split.length).join('<h3>');
    }));
  }
}
